import React from 'react';
import Modal from '../../components/Modal';
import styles from './index.module.scss';
import Button from '../../components/Button';

type Props = {
  onCancel: () => void;
};

const HelpModal = (props: Props) => {
  return (
    <>
      <Modal onClose={props.onCancel}>
        <div className={styles.wrapper}>
          <h1 className={styles.text}>Contact us</h1>
          <a href="mailto:support@myorganicapps.com">support@myorganicapps.com</a>
          <span>OR</span>
          <Button onClick={() => {
            window.location.href = 'mailto:support@myorganicapps.com'
          }} type={'success'}>
            Send email
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default HelpModal;
